module.exports = __webpack_public_path__ + "img/image_part_001.26f480a8.jpg";